import { Component, OnDestroy, ViewChild } from '@angular/core';
import { NbSidebarService } from '@nebular/theme';
import { Observable } from 'rxjs';
import { EquipeService } from '../../../../services/equipe.service';
import { ChatService } from '../../../../services/chat.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { EnviaMensagemComponent } from '../../../pages/atendimento-whatsapp/fila-atendimento/envia-mensagem/envia-mensagem.component';
import { ChatInterface, FilaAtendimentoComponent, MessageFormat } from '../../../pages/atendimento-whatsapp/fila-atendimento/fila-atendimento.component';
import { LoginService, UsuarioCompleto } from '../../../../services/login.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'ngx-one-column-layout',
  styleUrls: ['./one-column.layout.scss'],
  template: `
    <nb-layout windowMode>
      <nb-layout-header fixed>
        <ngx-header></ngx-header>
      </nb-layout-header>

      <nb-sidebar state="compacted" class="menu-sidebar" tag="menu-sidebar" responsive>
        <div class="main-container">
        <ng-content select="nb-menu"></ng-content>
        </div>
      </nb-sidebar>

      <nb-sidebar *ngIf="Equipe.length > 0 && Outros.length > 0" #filaSide class="fila-sidebar" right state="collapsed" fixed tag="fila-sidebar-right" responsive>
        <div class="row" style="height: 100%;">
        
         <div class="col-12 col-sm-4" style="height: 100%;">
            <app-fila-atendimento [EquipeFila]="Outros"></app-fila-atendimento>
          </div>
          <mat-divider vertical="true"></mat-divider>
        <div class="col-12 col-sm-4" style="height: 100%;">
            <app-fila-atendimento [EquipeFila]="Equipe"></app-fila-atendimento>
            <div class="botaoListaContato">
              <button color="contact" matTooltip="Lista de contatos" mat-raised-button
                (click)="abrirListaContato()">
                <mat-icon>chat</mat-icon> Iniciar Conversa
              </button>
            </div>
          </div>
        </div>
      </nb-sidebar>

      <nb-layout-column>
        <ng-content></ng-content>
      </nb-layout-column>

      <nb-layout-footer fixed>
        <ngx-footer></ngx-footer>
      </nb-layout-footer>
    </nb-layout>
  `,
})
export class OneColumnLayoutComponent implements OnDestroy {

  @ViewChild('filaSide') filaSide

  @ViewChild(FilaAtendimentoComponent) Fila: FilaAtendimentoComponent

  Equipe: any = []
  Outros: any = []
  altura
  usuarioLogado: UsuarioCompleto

  constructor(private sidebarService: NbSidebarService,
    private equipeService: EquipeService,
    private chatService: ChatService,
    private matDialog: MatDialog,
    public loginService: LoginService,
    public _snackBar: MatSnackBar
  ) {
    this.altura = window.innerHeight
    this.equipeService.getEquipeFila()
      .toPromise()
      .then(response => {
        // this.Equipe = response
        // this.Equipe = this.Equipe.filter((equipe) => equipe.IdChatEquipe != 98)
        // this.Outros = [this.Equipe[this.Equipe.length - 1]]
        response.forEach(equipe => {
          if (equipe.IdEquipeChat == "98" || equipe.IdEquipeChat == "119") {
            this.Outros.push(equipe);
          } else {
            this.Equipe.push(equipe);
          }
        });

        console.log(this.Equipe, this.Outros)

        if (this.Equipe.length > 0) {
          this.chatService.emitirHabilitaChat(this.Equipe, this.Outros)
        }
      })

    this.usuarioLogado = this.loginService.getUsuarioDadosCompletos()

    console.log(this.usuarioLogado)
  }

  ngOnDestroy(): void {
    this.chatService.emitirHabilitaChat([], [])
  }

  abrirListaContato() {

    const dialogConfig = new MatDialogConfig();

    dialogConfig.width = '40vw'
    dialogConfig.panelClass = 'customDialogEnvio'

    this.matDialog.open(EnviaMensagemComponent, dialogConfig)
      .afterClosed()
      .subscribe((response: MessageFormat) => {
        console.log(response)
        const chatInterface: ChatInterface = {
          NomeUsuarioWpp: response.nomeUsuario,
          Telefone: response.telefone,
          PhoneNumberIdProd: response.phoneNumberId,
          IdChatEquipe: response.idEquipeChat,
          Status: 'Em Atendimento',
          UsuarioAtendente: this.usuarioLogado.Nome,
          idCliente: response.idCliente,
          nomeCliente: response.nomeCliente,
          _id: '',
          from: 'Enviar'
        };
        this.Fila.iniciarConexaoChat(chatInterface)
      })
  }
}
